<form class="flex flex-col gap-4" (submit)="loadEvents($event)">
  <div class="grid gap-4 md:grid-cols-2">
    <fieldset class="border-outline grid gap-4 rounded border border-solid p-4 sm:grid-cols-2">
      <legend class="px-2 font-medium">Start</legend>

      <mat-form-field class="w-full">
        <mat-label>Start date</mat-label>
        <input matInput [matDatepicker]="startDatePicker" [formField]="periodForm.startDate">
        <mat-hint>DD/MM/YYYY</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="startDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #startDatePicker></mat-datepicker>

        @for (error of periodForm.startDate().errors(); track error.kind) {
        <mat-error>{{error.message}}</mat-error>
        }
      </mat-form-field>

      <mat-form-field class="w-full">
        <mat-label>Start time</mat-label>
        <input matInput [matTimepicker]="startTimePicker" [formField]="periodForm.startTime">
        <mat-timepicker-toggle matIconSuffix [for]="startTimePicker"></mat-timepicker-toggle>
        <mat-timepicker #startTimePicker></mat-timepicker>

        @for (error of periodForm.startTime().errors(); track error.kind) {
        <mat-error>{{error.message}}</mat-error>
        }
      </mat-form-field>
    </fieldset>

    <fieldset class="border-outline grid gap-4 rounded border border-solid p-4 sm:grid-cols-2">
      <legend class="px-2 font-medium">End</legend>

      <mat-form-field class="w-full">
        <mat-label>End date</mat-label>
        <input matInput [matDatepicker]="endDatePicker" [formField]="periodForm.endDate">
        <mat-hint>DD/MM/YYYY</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="endDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #endDatePicker></mat-datepicker>

        @for (error of periodForm.endDate().errors(); track error.kind) {
        <mat-error>{{error.message}}</mat-error>
        }
      </mat-form-field>

      <mat-form-field class="w-full">
        <mat-label>End time</mat-label>
        <input matInput [matTimepicker]="endTimePicker" [formField]="periodForm.endTime">
        <mat-timepicker-toggle matIconSuffix [for]="endTimePicker"></mat-timepicker-toggle>
        <mat-timepicker #endTimePicker></mat-timepicker>

        @for (error of periodForm.endTime().errors(); track error.kind) {
        <mat-error>{{error.message}}</mat-error>
        }
      </mat-form-field>
    </fieldset>
  </div>

  <div>
    <button matButton="filled"
            type="submit"
            [disabled]="!periodForm().valid() || periodForm().submitting()">
      <mat-icon>refresh</mat-icon>
      {{periodForm().submitting() ? 'Loading...' : 'Load Events'}}
    </button>
  </div>
</form>

@let vm = viewState();

@if (vm.isLoading) {
<div class="flex justify-center p-8" aria-label="Loading meter events">
  <mat-spinner diameter="40"></mat-spinner>
</div>
} @else if (vm.loadError) {
<p class="text-error py-4" role="alert">{{vm.loadError}}</p>
} @else if (vm.hasLoaded) {
  @if (vm.events.length === 0) {
    <p class="py-4">No meter events were found for this period.</p>
  } @else {
    <div class="mt-4 overflow-x-auto">
      <table mat-table [dataSource]="vm.events" aria-label="Meter events">
        <ng-container matColumnDef="time">
          <th mat-header-cell *matHeaderCellDef>Time</th>
          <td mat-cell *matCellDef="let event">{{ formatDateTime(event.eventTimestamp) }}</td>
        </ng-container>
        <ng-container matColumnDef="event">
          <th mat-header-cell *matHeaderCellDef>Event</th>
          <td mat-cell *matCellDef="let event">{{ event.eventName ?? 'Meter event' }}</td>
        </ng-container>
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef>Action</th>
          <td mat-cell *matCellDef="let event">{{ event.actionKey ?? 'Not specified' }}</td>
        </ng-container>
        <ng-container matColumnDef="credits">
          <th mat-header-cell *matHeaderCellDef>Credits</th>
          <td mat-cell *matCellDef="let event">{{ (event.credits ?? 0) | number }}</td>
        </ng-container>
        <ng-container matColumnDef="identifier">
          <th mat-header-cell *matHeaderCellDef>Identifier</th>
          <td mat-cell *matCellDef="let event">{{ event.identifier ?? 'Not available' }}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columns"></tr>
        <tr mat-row *matRowDef="let event; columns: columns"></tr>
      </table>
    </div>
  }
  <p class="mt-4"><strong>Total credits: {{ totalCredits() | number }}</strong></p>
}
